module.exports = __webpack_public_path__ + "img/selected4-min.1b703d96.png";